import * as runtime from '@/api/runtime'
import {
  BatchReserveContactMailSendRequest,
  BatchReserveContactMailSendRequestToJSON
} from '@/api/models/batch'

/**
 * 帳票作成
 */
export class BatchReserveContactMailSendApi extends runtime.BaseAPI {
  async return(request: BatchReserveContactMailSendRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/reserve/reserve-contact-mail-send`,
      BatchReserveContactMailSendRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
